module.exports = "/static/Images/pt-br/Neutral.png";